import styled, { useTheme } from "styled-components";
import Button from "./Button";
import React from "react";
import GreaterThan from "../icons/GreaterThan";
import { H1 } from "../texts";
import { device } from "../../theme";

const StyledLinkButton = styled(Button)`
    @media ${device.mobile} {
        width: 100%;
    }
`;

export const LinkButton = (props) => {
    const theme = useTheme();
    return (
        <StyledLinkButton {...props}>
            <H1 alt>{props.text}</H1>
            <GreaterThan stroke={theme.color.neutral.xxxlight} />
        </StyledLinkButton>
    );
};
export default LinkButton;
